import React, { useState, useEffect, useCallback } from 'react'
import usePlacesAutocomplete, {
    getGeocode,
    getDetails,
    getLatLng,
} from "use-places-autocomplete";
import { Container, Row, Col, Card, Tab, Form, Button, Nav, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap'

export default function AddressAutocomplete({ onSelect, defaultAddress = "" }) {
    const {
        ready,
        value,
        suggestions: { status, data },
        setValue,
        clearSuggestions,
    } = usePlacesAutocomplete({
        requestOptions: {
            /* Define search scope here */
        },
        debounce: 300,
    });


    useEffect(() => {
        if (defaultAddress) {
            setValue(defaultAddress, false);
        }
    }, [defaultAddress, setValue]);

    const handleSelect = async (address) => {
        setValue(address, false);
        clearSuggestions();

        try {
            const results = await getGeocode({ address });
            const details = await getDetails({ placeId: results[0].place_id });
            const latLng = await getLatLng(results[0]);

            // You can parse the full address components from details
            onSelect({ address, latLng, details });
        } catch (error) {
            console.error("Error fetching details:", error);
        }
    };

    return (
        <div>
            {/* <input
                value={value}
                onChange={(e) => setValue(e.target.value)}
                disabled={!ready}
                placeholder="Enter an address"
            /> */}
            <Form.Group className="form-group col-sm-12">
                <Form.Label className="form-label">Address:</Form.Label>
                <Form.Control as="textarea" className="form-control" placeholder="Your Address here"
                    value={value} onChange={(e) => setValue(e.target.value)}>
                </Form.Control>
            </Form.Group>
            {status === "OK" && (
                <ul>
                    {data.map(({ place_id, description }) => (
                        <li key={place_id} onClick={() => handleSelect(description)}>
                            {description}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
